import { useTaal } from "@/contexts/TaalContext";
/**
 * What a knowledge base holds, said on screen. One component, three places.
 *
 * A reference base behaves differently from every other base: it is skipped in
 * the sweep that runs on every chat, and an agent that names one gets a second
 * turn that puts the answer into shape. None of that is visible in a name, and
 * until 21 August 2026 none of it was visible anywhere at all. `kind` could
 * only be set with a hand written UPDATE against the live database, so the one
 * base that carried the flag carried it invisibly.
 *
 * SHARED AND NOT COPIED, on purpose. The three places this appears are the
 * list, the header of the base you have open, and the base picker on an agent
 * card. Three copies of a label drift, and drift here means the picker says
 * something the list does not.
 *
 * Only a reference base is marked. Labelling facts as well would turn the
 * exception into one label among several, which is the quiet way to make a
 * warning invisible: everything is tagged, so nothing stands out.
 *
 * Text and not an icon. The house rule forbids emoji as icons, and a line icon
 * on its own does not say what it means to someone who has not read this file.
 */

export const REFERENCE = "reference";
export const FACTS = "facts";

/** Whether this base holds reference material. Missing `kind` means facts:
 *  that is the column default, and it is what a response from before this
 *  field existed describes. */
export function isReference(kb) {
  return (kb || {}).kind === REFERENCE;
}

export default function KindBadge({ kb, className = "" }) {
  const { t } = useTaal();
  if (!isReference(kb)) return null;
  return (
    <span
      data-testid={`kind-badge-${(kb || {}).id}`}
      title={t("Vorm en uitgewerkte voorbeelden. Niet doorzocht in chats; gebruikt als een agent deze bank noemt.")}
      className={`shrink-0 rounded px-1.5 py-0.5 text-[10px] uppercase tracking-wide border border-[hsl(var(--accent))]/40 text-[hsl(var(--accent))] ${className}`}
    >
      {t("naslag")}
    </span>
  );
}
